import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Suspense } from 'react';
import { CookiesProvider } from 'react-cookie';

// Root de la aplicación
// de aqui re renderizan cada una de las pantallas de la aplicación

ReactDOM.render(
    <Suspense fallback="...">
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
